<mat-card class="content">
    <!--
      If you click image, it should open seeHouseDetails() right to images section.
    -->
    <!-- <img mat-card-image src="assets/images/yes.jpg" alt="Photo of a Shiba Inu"> -->
    <app-image-carousel *ngIf="post?.Media?.length" [images]="post.Media ?? []"></app-image-carousel>
    <!-- 
      Temporary, but this/[house] can be used for both sales&accommodations, [long-house] for map accommodation.
   -->
   <app-feed-accommodation-content *ngIf="post._type === 'accommodation'" [accommodation]="post"></app-feed-accommodation-content>
        
   <app-feed-sale-content *ngIf="post._type === 'sale'" [sale]="post"></app-feed-sale-content>
   
</mat-card>
